<template>
    <div>
        <div class="is-pc swiper-container-news">
            <img src="/src/assets/img/common/slider-arrow-prev-orange.png" alt="＜" class="slide-arrow prev-arrow">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(column, index) in pcColumnLists" :key=index>
                    <a :href="column.url">
                        <div class="c-slider-news__img">
                            <img :src="column.thumb_nail" alt="" loading="lazy">
                        </div>
                        <div class="c-slider-news__text">
                            <div class="c-slider-news__text-inner">
                                <p class="c-lead-bold">{{ column.title }}</p>
                                <div v-if="column.new" class="c-slider-normal__icon">
                                    <div class="c-label-new">New</div>
                                </div>
                                <div class="c-slider-normal__icon">
                                    <div class="piano-c-label-limited c-label is-weekly">{{ column.column_name }}</div>
                                </div>
                                <div class="c-slider-news__text-label">
                                    <p class="c-date">
                                    {{ column.show_date }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <img src="/src/assets/img/common/slider-arrow-next-orange.png" alt="＞" class="slide-arrow next-arrow">
        </div>
        <div class="is-sp">
            <div class="c-slider-news">
                <div class="c-slider-news__item" v-for="(column, index) in spColumnLists" :key=index>
                    <a :href="column.url">
                        <div class="c-slider-news__img">
                            <img :src="column.thumb_nail" alt="">
                        </div>
                        <div class="c-slider-news__text">
                            <div class="c-slider-news__text-inner">
                                <p class="c-lead-bold">{{ column.title }}</p>
                                <div v-if="column.new" class="c-slider-normal__icon">
                                    <div class="c-label-new">New</div>
                                </div>
                                <div class="c-slider-normal__icon">
                                    <div class="piano-c-label-limited c-label is-weekly">{{ column.column_name }}</div>
                                </div>
                                <div class="c-slider-news__text-label">
                                    <p class="c-date">
                                    {{ column.show_date }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import routeMixin from '../../mixins/route.js';
import Swiper from 'swiper/bundle';
import axios from 'axios';
import moment from "moment";
export default {
    props: {
        route_list: Object,
        recommend_categories: Array,
        recommend_from : String,
        recommender_string: String,
        number_of_result: String,
    },
    mixins: [routeMixin],
    data(){
        return{
            columnLists: []
        }
    },
    async mounted() {
        await this.makeData();

        // 3項目のため、専用のswiperを用意する
        const swiper = new Swiper('.swiper-container-news', {
            freeMode: {
                enabled: true,
                momentumBounce: true,
            },
            slidesPerView: 3,
            navigation: {
                nextEl: ".next-arrow",
                prevEl: ".prev-arrow",
            },
        });

        const carouselSp = new Swiper('.carousel-sp', {
            freeMode: {
                enabled: true,
                momentumBounce: true,
            },
            slidesPerView: 2.5,
            navigation: {
                nextEl: ".next-arrow",
                prevEl: ".prev-arrow",
            },
        });
    },
    computed: {
        pcColumnLists: function() {
            return this.columnLists.slice(0,4);
        },
        spColumnLists: function() {
            return this.columnLists.slice(0,1);
        }
    },
    methods:{
        getData: async function(){
            let url = this.route(this.route_list, 'site.api.recommender');;
            let columnLists = [];
            let params = {
                params: {
                    recommend_from : this.recommend_from,
                    recommender_string : this.recommender_string,
                    number_of_result : this.number_of_result,
                    recommend_categories : this.recommend_categories,
                }
            }
            let fall_back_param = {
                params: {
                    recommender_string : 'mostviewed',
                    number_of_result : this.number_of_result,
                    recommend_categories : this.recommend_categories,
                }
            }
            if (!this.recommend_from) {
                recommend_params = fall_back_param
            }

            let done = false;
            await axios.get(url, params)
            .then(res => {
                columnLists = res.data;
                done = true;
            }).catch(error => {

            });

            if (done && columnLists.length === 0) {
                await axios.get(url, fall_back_param
                ).then(res => {
                    columnLists = res.data;
                }).catch(error => {

                });
            }

            return columnLists;
        },
        makeData: async function(){
            let columnLists = await this.getData();

            columnLists.forEach(function(recommend){
                // Newフラグの付与を行う
                recommend.new = false;
                if(recommend.pub_date !== null) {
                    let startDate = moment(recommend.pub_date);
                    let lastDate = moment().subtract(7, 'days').startOf('days');
                    recommend.show_date = startDate.format('Y年M月D日');
                    if(startDate.isAfter(lastDate)) {
                        recommend.new = true;
                    }
                }
            });

            this.columnLists = columnLists;
        }
    }
}
</script>

<style scoped>
.swiper-container-news {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
}

.carousel-sp {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
}

.c-lead-bold {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 0;
    -webkit-box-orient: vertical;
    margin-bottom: 10px;
}

.next-arrow {
    right: -7px;
}
</style>
